import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PilotLandingPage from "@/pages/PilotLandingPage";
import DemoGenerator from "@/pages/DemoGenerator";
import AdminPilots from "@/pages/AdminPilots";
import AdminPilotDetail from "@/pages/AdminPilotDetail";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demo-generator" element={<DemoGenerator />} />
          <Route path="/admin/pilots" element={<AdminPilots />} />
          <Route path="/admin/pilots/:slug" element={<AdminPilotDetail />} />
          <Route path=":slug" element={<PilotLandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#101012",
            color: "rgba(255,255,255,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: 0,
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
